module.exports = __webpack_public_path__ + "img/怀来葡萄酒.7bb07380.jpg";